export const idx_data_pap_h = [];

let order = 0;
idx_data_pap_h.push({
  pap_h: '',
  order_idx: -1,
});

for (let i = 1; i <= 7; i++) {
  idx_data_pap_h.push({
    pap_h: i + '',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 1/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 1/8',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 3/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 1/4',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 5/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 3/8',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 7/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 1/2',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 9/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 5/8',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 11/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 3/4',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 13/16',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 7/8',
    order_idx: order,
  });
  order++;

  idx_data_pap_h.push({
    pap_h: i + ' 15/16',
    order_idx: order,
  });
  order++;
}
